<template>
	<div class="batch-main-table">
		<div class="fx-title">
			<p>商品信息</p>
		</div>
		<div class="main-table-box">
			<div style="display:flex">
				<el-button type="primary" size='small' class="fx-big-btn valet-add-btn" plain @click="addGoods" :disabled="!acountValue">添加商品</el-button>
				<label for="file">
					<el-button type="primary" size='small' class="fx-big-btn valet-add-btn" @click="importExcel" plain :disabled="!acountValue">批量导入商品</el-button>
				</label>
				<input type="file" ref="file" id="file" v-show="false" @change="getFile">
				<a href="javascript:void(0);" @click="downloadFile"  class="batch-register-btn">
					<i class="excel-icon export-excel-icon"/>
					<span>导入模板下载</span>
				</a>
			</div>
			<el-table
				class="grid-content"
				:data="tableData"
				border
			>
				<el-table-column
					label-class-name="column-index"
					label="序号"
					type="index"
					width="70"
					align="center">
				</el-table-column>
				<el-table-column
					prop="url"
					label="商品图片"
					align="center">
					<template slot-scope="scope">
						<div class="shop-info">
							<w-image :src="scope.row.url" alt="" :onerror="errorImgUrl" width="50" height="50"></w-image>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="productname"
					label="商品名称"
					align="center"
					min-width="120">
					<template slot-scope="scope">
						<div style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
							<div v-if="scope.row.giftflag" class="giftLogo">赠品</div>
							<div>{{scope.row.productname}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					v-if="matchbillcenterflag === 1"
					prop="code"
					label="第三方编号"
					align="center"
					min-width="120"
					:show-overflow-tooltip = "true">
					<template slot-scope="scope">
						<div>{{scope.row.matchcode}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="code"
					label="规格编号"
					align="center">
					<template slot-scope="scope">
						<div>{{scope.row.specCode}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="spec"
					label="规格"
					align="center">
					<template slot-scope="scope">
						<div>{{scope.row.spec}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="unit"
					label="单位"
					min-width="120"
					align="center">
					<template slot-scope="scope">
						<el-select v-if="scope.row.useUnitFlag" @change="typeChange(scope.row)" size="mini" v-model="scope.row.unitType" placeholder="请选择">
							<el-option :value="0" :label="scope.row.baseUnitName"></el-option>
							<el-option :value="1" :label="scope.row.assistUnitName +'(='+scope.row.assistRatio + scope.row.baseUnitName+ ')'"></el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column
						prop="inventory"
						label="库存"
						align="center">
						<template slot-scope="scope">
							<div :style="scope.row.inventory === 0 ? 'color: red' : ''">{{scope.row.useUnitFlag === 1 && scope.row.unitType === 1 ? scope.row.unitInventory : scope.row.inventory}}</div>
						</template>
					</el-table-column>
				<el-table-column
					prop="customPrice"
					label="单价"
					align="center">
					<template slot-scope="scope">
						<!-- <div :style="{'color': scope.row.realPrice === 0 ? 'red' : ''}" v-if="!scope.row.giftflag">{{scope.row.realPrice}}</div> -->
						<!-- <div style="color:red" v-else>0.00</div> -->
						<el-input
							:style="{'color': scope.row.realPrice === 0 ? 'red' : ''}"
							@change='priceChange(scope.row, "realPrice", 2)'
							@input='checkPrice(scope.row, "realPrice", 2)'
							@blur="priceBlur(scope.row)"
							:disabled="!AuthorityList['07_0007_0001_00']"
							v-model="scope.row.realPrice"
							v-if="!scope.row.giftflag"
							class="filter-input"
							:class="{'border-red': scope.row.isRed}"
							size="mini"></el-input>
						<div style="color:red" v-else>0.00</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="itemquantity"
					label="数量"
					align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.itemquantity" @input="quantityInput(scope.row)" @blur="quantityBlur(scope.$index)" class="filter-input" size="mini"></el-input>
					</template>
				</el-table-column>
				<el-table-column
					prop="itemmoney"
					label="小计"
					align="center">
					<template slot-scope="scope">
						<div v-if="!scope.row.giftflag">{{scope.row.itemmoney}}</div>
						<div v-else>0.00</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="memo"
					label="备注"
					align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.memo" size="mini" maxlength="200"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="deleteSingle(scope.$index)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="goods-total">
			<div><span>商品数量合计：</span>{{totalQuantity}}</div>
			<div><span>商品金额合计：</span>￥{{goodsMoney}}</div>
			<div><span>运费：</span>
			<el-input type="number" v-model="freight" @input="freightInput" @blur="freightChange" :disabled="freightCheck" class="filter-input" size="mini"></el-input>
			<el-checkbox v-model="freightCheck" @change='checkChange' style="margin-left:10px;">系统计算运费</el-checkbox></div>
			<div><span>支付总数：</span>￥{{totalMoney}}</div>
		</div>
		<div v-if="Object.keys(customData).length !== 0">
			<div class="fx-title">
				<p>支付方式</p>
			</div>
			<div class="info-box">
				<div v-if="showOffline && !customData.canpaylaterflag">
					<el-checkbox v-model="isOffLine" @change="offlineChange" style="margin-top:3px;">线下支付，直接发货</el-checkbox>
				</div>
				<div v-if="!customData.canpaylaterflag && showPre">
					<el-checkbox v-model="isAdvance" @change="advanceChange" style="margin-top:3px;">预付货款</el-checkbox>
				</div>
				<div style="margin-top: 10px;padding-left: 37px;" v-if="showPre">
					<div v-if="isAdvance">可用预付货款余额: ￥<span :style="parseFloat(totalMoney) !== 0 && parseFloat(usablepremoney)<parseFloat(totalMoney) ? 'color:red' : ''">{{usablepremoney}}</span></div><br>
					<div v-if="(customData.canpaylaterflag && customData.creditlineflag) || (!customData.canpaylaterflag && parseFloat(totalMoney) !== 0 && parseFloat(usablepremoney)<parseFloat(totalMoney) && customData.creditlineflag) && isAdvance">可用信用额度: ￥<span :style="parseFloat(totalMoney) !== 0 && parseFloat(usablecreditline)<parseFloat(totalMoney) ? 'color:red' : ''">{{usablecreditline}}</span></div>
				</div>
			</div>
		</div>
		<el-dialog
			title="添加商品"
			:visible.sync="dialogVisible"
			class="dialog-title"
			width="1200px"
			@close='dialogClose'
			@open="search('0')"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div class="filters-container">
					<div class="search-left">
						<div class="input-box">
							<span>商品信息：</span>
							<el-input
								v-model="goodsName"
								placeholder="请输入商品名称/规格编号/第三方编号"
								size="small"
								style="width:250px"
								@keyup.enter.native="search('0')">
							</el-input>
						</div>
						<div class="input-box">
							<span>店铺大类：</span>
							<el-select v-model="bigClass" class="filter-input" size='small' @change="getsmallClass">
								<el-option :value="item.bc_id" :label="item.bc_name" v-for="item in bigClassList" :key="item.shopCategoryId"></el-option>
							</el-select>
						</div>
						<div class="input-box">
							<span>店铺小类：</span>
							<el-select v-model="smallClass" class="filter-input" size='small'>
								<el-option :value="item.id" :label="item.name" v-for="item in smallClassList" :key="item.id"></el-option>
							</el-select>
						</div>
					</div>
					<div class="search-right">
						<el-button size="small" type="primary" class="btn fx-btn" @click="search('0')">查询</el-button>
						<el-button size="small" plain class="btn fx-btn" @click="clear">清空</el-button>
					</div>
				</div>
				<el-table
					class="grid-content"
					:data="tableData2"
					border
					max-height="600"
					@selection-change="selectionChangeHandle"
					ref="DataTable"
				>
					<el-table-column
						type="selection"
						align="center"
						width="55"
						fixed>
					</el-table-column>
					<el-table-column
						label-class-name="column-index"
						label="序号"
						type="index"
						width="70"
						align="center"
						fixed>
					</el-table-column>
					<el-table-column
						prop="productname"
						label="商品名称"
						width="320"
						align="center"
						:show-overflow-tooltip = "true"
						fixed>
					</el-table-column>
						<el-table-column
						prop="spec"
						label="规格"
						min-width="120"
						align="center"
						:show-overflow-tooltip = "true"
						fixed>
						<template slot-scope="scope">
							<div>{{scope.row.spec}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="customPrice"
						label="单价"
						align="center"
						:show-overflow-tooltip = "true"
						fixed>
						<template slot-scope="scope">
							<!-- <div>{{scope.row.speprice || scope.row.customPrice}}</div> -->
							<el-input
							:ref="'price' + scope.$index"
							@keydown.enter.native="keyDown(scope.$index, scope.row, 'enter1')"
							@change='priceChange(scope.row, "realPrice")'
							@input='checkPrice(scope.row, "realPrice")'
							@blur="priceBlur(scope.row)"
							v-model="scope.row.realPrice"
							v-if="!scope.row.giftflag"
							:disabled="!scope.row.selected || !AuthorityList['07_0007_0001_00']"
							class="filter-input"
							size="mini"></el-input>
							<div style="color:red" v-else>0.00</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="unit"
						label="单位"
						min-width="120"
						:show-overflow-tooltip = "true"
						align="center">
						<template slot-scope="scope">
							<el-select v-if="scope.row.useUnitFlag" :disabled="!scope.row.selected" @change="typeChange(scope.row)" size="mini" v-model="scope.row.unitType" placeholder="请选择">
								<el-option :value="0" :label="scope.row.baseUnitName"></el-option>
								<el-option :value="1" :label="scope.row.assistUnitName +'(='+scope.row.assistRatio + scope.row.baseUnitName+ ')'"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column
						prop="inventory"
						label="库存"
						:show-overflow-tooltip = "true"
						align="center">
						<template slot-scope="scope">
							<div :style="scope.row.inventory === 0 ? 'color: red' : ''">{{scope.row.unitType === 1 ? scope.row.unitInventory : scope.row.inventory}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="minbuycnt"
						label="最小订货数"
						align="center"
						:show-overflow-tooltip = "true"
						width="120">
						<template slot-scope="scope">
							<div>{{scope.row.minbuycnt}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="itemquantity"
						label="数量"
						:show-overflow-tooltip = "true"
						align="center">
						<template slot-scope="scope">
							<el-input
							:ref="'number' + scope.$index"
							@keydown.enter.native="keyDown(scope.$index, scope.row, 'enter2')"
							@input='checkNum(scope.row)'
							@blur='numBlur(scope.row)'
							v-model="scope.row.itemquantity"
							:disabled="!scope.row.selected"
							class="filter-input"
							size="mini"></el-input>
						</template>
					</el-table-column>
					<el-table-column
						prop="giftflag"
						label="赠品"
						align="center"
						:show-overflow-tooltip = "true"
						width="115">
						<template slot="header">
							<div style="position:relative">赠品
								<el-tooltip class="item" effect="dark" placement="top-start">
									<div slot="content">1.打开开关添加商品数据为赠品；<br/>2.添加非赠品商品数据请关闭开关</div>
									<img src="~/images/icon/tooltip-icon.png" class="spec-title">
								</el-tooltip>
							</div>
						</template>
						<template slot-scope="scope">
							<div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;padding:0px 5px">
								<el-switch
									@change="calcGoodsMoney"
									v-model="scope.row.giftflag"
									:disabled="!scope.row.selected || scope.row.giftdisableflag"
									active-color="#13ce66">
								</el-switch>
								<span v-if="scope.row.giftflag">赠送</span>
								<span v-else>不赠送</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="memo"
						label="备注"
						align="center"
						:show-overflow-tooltip = "true">
						<template slot-scope="scope">
							<el-input
								:ref="'memo' + scope.$index"
								@keydown.enter.native="keyDown(scope.$index, scope.row, 'enter3')"
								v-model="scope.row.memo"
								size="mini" maxlength="200"
								:disabled="!scope.row.selected"
							></el-input>
						</template>
					</el-table-column>
					<el-table-column
						prop="code"
						label="规格编号"
						width="320"
						align="center"
						:show-overflow-tooltip = "true">
						<template slot-scope="scope">
							<div>{{scope.row.specCode}}</div>
						</template>
					</el-table-column>
					<el-table-column
						v-if="matchbillcenterflag === 1"
						prop="code"
						label="第三方编号"
						align="center"
						min-width="120"
						:show-overflow-tooltip = "true">
						<template slot-scope="scope">
							<div>{{scope.row.matchcode}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="bshopcategory"
						label="店铺大类"
						min-width="120"
						align="center"
						:show-overflow-tooltip = "true">
					</el-table-column>
					<el-table-column
						prop="sshopcategory"
						label="店铺小类"
						min-width="120"
						align="center"
						:show-overflow-tooltip = "true">
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button type='text' size="mini" @click="addSingle(scope.row)">添加</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handlePageChange"
					:current-page="pagination.page"
					:page-sizes="[20, 40, 60, 100, 300]"
					:page-size="pagination.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalCount">
				</el-pagination>
				<div class="valet-foot">
					<div class="tip-box">选择{{selectNum}}种商品规格，其中赠品有{{giftNum}}种</div>
					<el-button class="btn" plain type="primary" size='small' @click="close">取消</el-button>
					<el-button class="btn" plain type="primary" size='small' @click="addMulti">添加</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="提示" class="dialog-title" :visible.sync="tipModal" width='400px' :close-on-click-modal="false">
			<div style="padding-bottom:20px" v-for="item in tipData" :key="item">
				{{item}}
			</div>
		</el-dialog>
		<el-dialog title="提示" class="confirm-dialog" top='60px' :visible.sync="mergeModel" width='400px' :close-on-click-modal="false">
			<div style="margin-bottom:10rpx;max-height:250px;overflow:auto">
				{{mergeTip}}
			</div>
			<div style="width:100%;text-align: center;margin-top:40px">
				<el-button size="small" style="width: 120px;" plain type="primary" @click="handleMergeClick('cancel')">重新上传</el-button>
				<el-button size="small" style="width: 120px;" plain type="primary" @click="handleMergeClick('merge')">确认合并</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		bigClassList: {
			type: Array
		},
		shopId: {
			type: String
		},
		organid: {
			type: String
		},
		buyersyscodeid: {
			type: String
		},
		acountValue: {
			type: String
		},
		address: {
			type: String
		},
		addressType: {
			type: String
		},
		orderNumberRoundRules: {
			type: Number
		},
		orderdecimalcount: {
			type: Number
		}
	},
	data () {
		return {
			AuthorityList: {
				'07_0007_0001_00': false,
				'07_0007_0002_00': false
			},
			tableHeight: '100%',
			pagination: {
				page: 1,
				size: 20
			},
			dialogVisible: false,
			tipModal: false,
			mergeModel: false,
			curItemData: {},
			tableData: [],
			tableData2: [],
			tipData: [],
			errorImgUrl: 'this.src="' + require('$assets/images/img/no-goods-img.png') + '"',
			goodsMoney: '0.00',
			freight: 0,
			freightCheck: false,
			totalMoney: '0.00',
			goodsName: '',
			speccode: '',
			bigClass: '',
			smallClass: '',
			smallClassList: [{ name: '全部', id: '' }],
			ids: [],
			totalCount: 0,
			giftNum: 0,
			selectNum: 0,
			selectTableData: [],
			matchbillcenterflag: 1,
			actualtimeinventoryflag: 1, // 0：不开启实时库存 1：开启实时库存
			// orderNumberRoundRules: null,
			// orderdecimalcount: null,
			mergeTip: '',
			refundFlag: false,
			dataObj: {},
			isOffLine: false,
			isAdvance: false,
			customData: {},
			usablepremoney: 0,
			usablecreditline: 0,
			showOffline: false,
			showPre: false,
			cusId: ''
		}
	},
	watch: {
		bigClassList (val) {
			this.getsmallClass()
		},
		customData (val) {
			console.log(val)
			this.cusId = val.id
			this.getUsablepremoney()
			this.isOffLine = false
			this.isAdvance = false
			this.showOffline = false
			this.showPre = false
			// this.usablepremoney = this.$fxUtils.toFixedSHW(val.usablepremoney, 2)
			this.usablecreditline = this.$fxUtils.toFixedSHW(val.usablecreditline, 2)
			if (!val.canpaylaterflag) {
				let list = val.paymodes
				if (list.includes('0')) {
					this.showOffline = true
				}
				if (list.includes('4')) {
					this.showPre = true
				}

				if (this.showOffline && this.showPre) {
					this.isOffLine = true
				} else if (this.showOffline || this.showPre) {
					if (this.showOffline) {
						this.isOffLine = true
					}
					if (this.showPre) {
						this.isAdvance = true
					}
				}
			}
		}
	},
	created () {
		this.checkSmallCategory()
		// this.getSystemSetting()
		this.getAuthority('07_0007_0000_00')
	},
	mounted () {
		this.refundFlag = this.$route.query.refundFlag
		if (this.refundFlag) {
			this.initTableData()
		}
	},
	computed: {
		totalQuantity () {
			return this.tableData.reduce((pre, cur) => {
				return pre + (cur['itemquantity'] - 0)
			}, 0)
		}
	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		getMsg () {
			let product = []
			this.tableData.forEach(item => {
				let row = '商品名称：' + item.productname + '商品规格：' + item.spec + '单价：' + (item.giftflag ? 0 : item.realPrice) + '数量：' + item.itemquantity + '小计：' + (item.giftflag ? 0 : item.itemmoney)
				product.push(row)
			})

			let productMsg = '商品：' + product.join(',')
			let pay = ''
			if (this.isOffLine || this.isAdvance) {
				pay = '支付方式为' + (this.isOffLine ? '线下支付' : '预付货款')
			}
			let msg = productMsg + pay
			return msg
		},
		offlineChange (e) {
			if (e) {
				this.isAdvance = !e
			}
		},
		getUsablepremoney () {
			let params = {
				customerid: this.cusId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/order/prepayment/current`,
				data: params
			}).then(res => {
				if (res.data === -1) {
					this.$message.error('获取系统余额失败，请检查网络后重试！')
					this.isAdvance = false
					return false
				}
				this.usablepremoney = res.data
			})
		},
		advanceChange (e) {
			console.log(e)
			if (e) {
				this.isOffLine = !e
				this.getUsablepremoney()
			}
		},
		checkChange () {
			this.freight = 0
			this.totalMoney = this.goodsMoney
		},
		freightChange () {
			if (this.freight === '' || this.freight < 0 || parseFloat(this.freight).toString() === 'NaN') {
				this.freight = 0
			} else {
				this.freight = this.$fxUtils.toFixedSHW(this.freight, 2)
			}
		},
		freightInput () {
			if (this.freight === '' || this.freight < 0 || parseFloat(this.freight).toString() === 'NaN') {
				this.totalMoney = this.goodsMoney
			} else {
				this.totalMoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(+this.goodsMoney + (+this.freight), 2) : this.toFix(+this.goodsMoney + (+this.freight))
			}
		},
		typeChange (row) {
			if (row.unitType === 1) {
				// if (row.isImportFlag) {
				// 	row.realPrice = this.toFix(row.importPrice)
				// } else {
				// 	row.realPrice = this.toFix(row.basePrice)
				// }
				let price = row.basePrice * row.assistRatio
				row.realPrice = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(price, 2) : this.toFix(price)
			} else {
				row.realPrice = row.basePrice
			}
			this.calcGoodsMoney()
		},
		numBlur (row) {
			row.itemquantity = +row.itemquantity
		},
		checkNum (row) {
			row.itemquantity = row.itemquantity.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.itemquantity = row.itemquantity.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.itemquantity = row.itemquantity.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.itemquantity = row.itemquantity.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.orderdecimalcount) {
			case 0:
				row.itemquantity = row.itemquantity.replace(/[^0-9]/g, '')// 只能输入数字
				break
			case 1:
				row.itemquantity = row.itemquantity.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				row.itemquantity = row.itemquantity.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				row.itemquantity = row.itemquantity.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				row.itemquantity = row.itemquantity.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
		},
		priceBlur (row) {
			row.realPrice = this.$fxUtils.toFixedSHW(row.realPrice, 2)
		},
		priceChange (row, name, type) {
			if (row.realPrice === undefined || +row.realPrice < 0) {
				row.realPrice = '0.00'
			}
			if (row.realPrice === '') {
				row.realPrice = ''
			}
			if (+row.realPrice > 999999.99) {
				row.realPrice = 999999.99
			}
			// this.priceBlur(row)
			if (type === 2) {
				this.calcGoodsMoney()
			}
		},
		checkPrice (item, name, type) {
			item[name] = item[name].replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			item[name] = item[name].replace(/^\./g, '')// 验证第一个字符是数字而不是
			item[name] = item[name].replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			item[name] = item[name].replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			item[name] = item[name].replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入一个小数
			if (type === 2) {
				this.calcGoodsMoney()
			}
		},
		getSystemSetting () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/order/getOrderSystemSetting`
			}).then(res => {
				this.orderNumberRoundRules = res.data.ordermoneyroundrules
				this.orderdecimalcount = res.data.orderdecimalcount
			})
		},
		importExcel () {
			if (this.tableData.length !== 0) {
				this.$confirm('商品信息列表已有数据,不支持批量导入数据,是否删除列表已有数据？', '提示', {
					confirmButtonText: '确认删除',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.tableData = []
					this.goodsMoney = '0.00'
					this.totalMoney = '0.00'
					this.$refs.file.dispatchEvent(new MouseEvent('click'))
				}).catch(() => {
				})
			} else {
				this.$refs.file.dispatchEvent(new MouseEvent('click'))
			}
		},
		// 导入
		getFile (e) {
			this.uploadGoodsHandle()
		},
		uploadGoodsHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				formData.append('shopid', this.shopId)
				formData.append('syscodeid', this.buyersyscodeid)
				formData.append('priceAuthority', this.AuthorityList['07_0007_0001_00'] ? 1 : 0)
				if (!this.mergeModel) {
					formData.append('action', 0)
				}
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/replacorder/importExcel`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.mergeModel = false
						let inportData = JSON.parse(JSON.stringify(res.data))
						inportData.forEach(item => {
							item.realPrice = item.customPrice || item.speprice
							item.unitType = 1
							item.realPrice = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(item.realPrice, 2) : this.toFix(item.realPrice)
							item.selected = true
							item.isRed = false
							// item.basePrice = item.realPrice
							if (item.useUnitFlag === 1) {
								let price = item.realPrice / item.assistRatio
								// item.realPrice = this.toFix(price)
								item.basePrice = this.toFix(price)
								item.unitInventory = this.toFix(item.inventory / item.assistRatio)
								item.importPrice = item.realPrice
							}
							item.isImportFlag = true
						})
						this.tableData = inportData
						// console.log(this.tableData)
						if (res.msg) {
							this.$message.warning(res.msg)
						} else {
							this.$message.success('导入成功！')
						}
						this.calcGoodsMoney()
						this.$refs.file.value = ''
						// this.tableReload()
					} else {
						if (res.code === 0) {
							this.mergeTip = res.data
							this.mergeModel = true
						} else {
							this.$refs.file.value = ''
							this.tipData = res.data
							this.tipModal = true
						}
						// this.$refs.file.value = ''
						// this.errorMsgList = res.data
						// this.errorMsgModel = true
					}
				})
			})
		},
		// 是否对接中台
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
				this.actualtimeinventoryflag = res.actualtimeinventoryflag
			})
			// })
		},
		// 计算价格
		calcGoodsMoney () {
			let price = 0
			let num = 0
			this.tableData.forEach(item => {
				var quantity = (item.itemquantity * item.realPrice)
				item.itemmoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(quantity, 2) : this.toFix(quantity)
				if (!item.giftflag) {
					price += +item.itemmoney
				}
				if (item.speprice) {
					item.speprice = item.realPrice
				} else {
					item.customPrice = item.realPrice
				}
			})
			this.selectTableData.forEach(item => {
				if (item.giftflag) {
					num++
				}
			})
			this.giftNum = num
			this.goodsMoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(price, 2) : this.toFix(price)
			this.totalMoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(+this.goodsMoney + (+this.freight), 2) : this.toFix(+this.goodsMoney + (+this.freight))
		},
		toFix (price) {
			if (+price === 0) {
				return '0.00'
			}
			let num = isNaN(price) ? 0 : price
			num = +num + 0.0000000001
			num = num + ''
			if (num.indexOf('.') !== -1) {
				num = num.substring(0, num.indexOf('.') + 3)
			}
			return num
		},
		// 修改数量
		quantityInput (e) {
			this.checkNum(e)
			this.calcGoodsMoney()
		},
		quantityBlur (index) {
			if (this.tableData[index].itemquantity === '') {
				this.tableData[index].itemquantity = 1
				// this.calcFreight()
			} else {
				this.tableData[index].itemquantity = +this.tableData[index].itemquantity
			}
		},
		// 删除商品
		deleteSingle (index) {
			this.tableData.splice(index, 1)
			this.calcGoodsMoney()
			this.$message.success('删除成功')
			// this.calcFreight()
		},
		// 单个添加
		addSingle (item) {
			if (item.itemquantity === '') {
				item.itemquantity = item.minbuycnt === 0 ? 1 : item.minbuycnt
			}
			var itemmoney = item.itemquantity * item.realPrice
			item.itemmoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(itemmoney, 2) : this.toFix(itemmoney)
			item.isRed = false
			this.tableData.push(item)
			this.search()
			this.calcGoodsMoney()
			// this.calcFreight()
		},
		// 批量添加
		addMulti () {
			let selectData = this.$refs.DataTable.selection
			if (selectData.length === 0) {
				this.$message.error('请选择商品！')
				return false
			}
			selectData.forEach(item => {
				if (item.itemquantity === '') {
					item.itemquantity = item.minbuycnt === 0 ? 1 : item.minbuycnt
				}
				item.itemmoney = this.$fxUtils.toFixedSHW((item.itemquantity * item.realPrice), 2)
				item.isRed = false
				this.tableData.push(item)
			})
			this.calcGoodsMoney()
			this.$message.success('添加成功！')
			this.search('0')
			// this.search()
			// this.calcFreight()
			// this.dialogVisible = false
		},
		// 获取小类
		getsmallClass () {
			let data = {
				pid: this.bigClass,
				shopId: this.shopId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: data
			}).then(res => {
				if (res.result) {
					this.smallClass = ''
					let all = { name: '全部', id: '' }
					res.data.unshift(all)
					this.smallClassList = res.data
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		search (val) {
			if (val === '0') {
				this.pagination.page = 1
			}
			let data = {
				shopid: this.shopId,
				syscodeid: this.buyersyscodeid,
				keyword: this.goodsName,
				specCode: this.speccode,
				bigTypeCategory: this.bigClass,
				smallTypeCategory: this.smallClass,
				paramList: this.tableData,
				page: this.pagination.page,
				size: this.pagination.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/replacorder/productlist`,
				data: data
			}).then(res => {
				if (res.recordList === null) {
					this.tableData2 = []
				} else {
					res.recordList.forEach((e, index) => {
						if (e.commpressflag) {
							if (e.url) {
								e.url = this.$fxUtils.changeImgSrc(e.url, 'big')
							}
						}
						if (e.speprice === 0) {
							e.speprice = e.speprice.toString()
						}
						e.selected = false
						e.itemquantity = ''
						e.memo = ''
						e.basePrice = e.speprice || e.customPrice
						e.unitType = 0
						e.realPrice = e.speprice || e.customPrice
						e.currentIndex = index
						if (e.useUnitFlag === 1) {
							e.unitType = 1
							let price = e.basePrice * e.assistRatio
							e.realPrice = this.toFix(price)
							if (e.inventory < 0) {
								e.unitInventory = -(this.toFix((-e.inventory) / e.assistRatio))
							} else {
								e.unitInventory = this.toFix(e.inventory / e.assistRatio)
							}
						}
					})
					this.tableData2 = res.recordList
				}
				this.totalCount = res.recordCount
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		clear () {
			this.goodsName = ''
			this.bigClass = ''
			this.smallClass = ''
			this.search('0')
		},
		selectionChangeHandle (value) {
			let giftNum = 0
			this.selectNum = value.length
			this.selectTableData = value
			let ids = value.map((item) => {
				return item.attrplanid
			})
			for (let i = 0; i < this.tableData2.length; i++) {
				if (ids.indexOf(this.tableData2[i].attrplanid) !== -1) {
					if (this.tableData2[i].giftflag) {
						giftNum++
					}
					this.tableData2[i].selected = true
					if (this.tableData2[i].itemquantity === '') {
						this.tableData2[i].itemquantity = this.tableData2[i].minbuycnt === 0 ? 1 : this.tableData2[i].minbuycnt
					}
				} else {
					this.tableData2[i].selected = false
				}
			}
			this.giftNum = giftNum
		},
		addGoods () {
			this.dialogVisible = true
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.search()
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.search()
		},
		dialogClose () {
			this.tableData2 = []
			this.pagination.page = 1
			this.bigClass = ''
			this.smallClass = ''
			this.goodsName = ''
			this.speccode = ''
			this.getsmallClass()
			// this.smallClassList = [{ shopCategoryName: '全部', id: '' }]
		},
		close () {
			this.dialogVisible = false
		},
		handleMergeClick (val) {
			if (val === 'cancel') {
				this.$refs.file.value = ''
				this.mergeModel = false
				this.$refs.file.dispatchEvent(new MouseEvent('click'))
			} else if (val === 'merge') {
				this.uploadGoodsHandle()
			}
		},
		// 处理退单详情跳转带过来的tableData
		initTableData () {
			this.$fxEventBus.$on('table', (data) => {
				this.tableData = JSON.parse(JSON.stringify(data))
				this.tableData.forEach((item, index) => {
					this.$set(item, 'memo', '')
					this.$set(item, 'unitType', 0)
					item.isRed = false
					item.basePrice = item.speprice || item.customPrice
					item.realPrice = item.speprice || item.customPrice
					if (item.useUnitFlag === 1) {
						let price = item.basePrice * item.assistRatio
						item.unitType = 1
						item.realPrice = this.toFix(price)
						item.unitInventory = this.toFix(item.inventory / item.assistRatio)
					}
				})
				this.calcGoodsMoney()
			})
		},
		downloadFile () {
			let url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/business/qshop/replacorder/代客下单商品导入订单模版.xlsx?timeStamp=' + new Date().getTime()
			window.location.href = url
		},
		keyDown (index, row, name) {
			// if (index !== this.tableData.length - 1) {
			this.$nextTick(e => {
				if (name === 'enter1') {
					let ref = 'number' + index
					if (this.$refs[ref]) {
						this.$refs[ref].focus()
					} else {
						return false
					}
				} else if (name === 'enter2') {
					let ref = 'memo' + index
					if (this.$refs[ref]) {
						this.$refs[ref].focus()
					} else {
						return false
					}
				} else {
					this.selectTableData = this.selectTableData.sort(this.compare('currentIndex'))
					this.selectTableData.forEach((item, index) => {
						if (item.attrplanid === row.attrplanid) {
							if (this.selectTableData[index + 1]) {
								row.nextIndex = this.selectTableData[index + 1].currentIndex
								row.nextFlag = this.selectTableData[index + 1].giftflag
							} else {
								row.nextIndex = this.selectTableData[0].currentIndex
								row.nextFlag = this.selectTableData[0].giftflag
							}
						}
					})
					console.log(row)
					if (!row.nextFlag) {
						let ref = 'price' + row.nextIndex
						if (this.$refs[ref]) {
							this.$refs[ref].focus()
						} else {
							return false
						}
					} else {
						let ref = 'number' + row.nextIndex
						if (this.$refs[ref]) {
							this.$refs[ref].focus()
						} else {
							return false
						}
					}
				}
			})
			// }
		},
		// 对selectTableData按顺序进行排序
		compare (prop) {
			return function (obj1, obj2) {
				var val1 = obj1[prop]
				var val2 = obj2[prop]
				if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
					val1 = Number(val1)
					val2 = Number(val2)
				}
				if (val1 < val2) {
					return -1
				}	else if (val1 > val2) {
					return 1
				} else {
					return 0
				}
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.batch-main-table {
	display flex
	// flex: 1
	flex-direction: column
	// height: 100%
	padding-left: 10px
	font-size: 14px
	margin-top: 10px
	text-align: left
	.fx-title {
		font-weight: 700
		margin: 10px 0 10px 0
	}
	.info-box {
		text-align: left
		&>div {
			// display: flex
			// align-items: center
			padding-left: 14px
			margin-top: 15px
		}
	}
	.main-table-box {
		flex: 1
		padding-bottom 10px
		overflow-y: auto;
		.valet-add-btn {
			margin: 10px 10px 10px 0
		}
		.shop-info{
			display: flex
			justify-content: center;
		}
	}
	.goods-total {
		display: flex
		flex-direction: column
		justify-content: flex-end
		padding-left: 60%
		margin: 20px 0
		&>div {
			margin: 3px 0
			&>span {
				display: inline-block
				width: 110px;
				text-align: right
			}
		}
		.el-input {
			width: 100px
		}
	}
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin: 10px;
		margin-left: 0;
		width: 100px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
}
</style>
<style lang="stylus">
.giftLogo{
	margin-right :5px;
	font-size :10px;
	width: 34px;
	height: 18px;
	line-height: 18px;
	color: var(--fx-primary-color);
	border: 1px solid var(--fx-primary-color);
	border-radius :5px;
}
.spec-title {
	width: 14px;
	height: 14px;
	position: absolute;
	top: 4px;
	right: 15px;
	cursor: pointer
}
.border-red input.el-input__inner{
	border-color: #F56C6C
}
.batch-main-table {
	.el-dialog {
		margin-top: 5vh!important
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px;
		padding-bottom: 10px;
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-pagination {
		text-align: center;
		margin-top: 10px
	}
	.valet-foot {
        height :40px;
        margin-top: 10px;
		text-align: center
		position :relative
        .btn{
            width :120px;
			height :35px;
			margin: 0 30px
        }
		.tip-box{
			position :absolute;
			width:400px;
			bottom :8px;
			text-align :left;
			left :750px;
			color :#999999
		}
	}
	.el-radio {
		margin-right: 20px;
		&:last-child {
			margin-right: 0
		}
	}
	.btn-box {
		display flex
		justify-content: center
		.el-button {
			width: 120px
		}
	}
	.filters-container {
		display: flex
		justify-content: space-between
		margin-bottom: 20px
		.input-box {
			margin-right: 10px
			&>span {
				display: inline-block;
				width: 85px;
				text-align: right
			}
		}
		.el-input {
			width: 160px
		}
		.filter-input {
			width: 160px
		}
		.search-left {
			display: flex;
			flex-wrap: wrap
		}
		.search-right {
			width: 150px;
			flex-shrink: 0
		}
	}
}
</style>
